export const subscriptionsQueryOptions = {
  GET_SUBSCRIPTIONS: 'getSubscriptions'
}

export const subscriptionMutationOptions = {
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe'
}

export const subscriptionTypeOptions = {
  PLANS: 'plans',
  GROUP: 'group',
  PINS: 'pins'
}
